import { api } from "..";

export const fundObligationsPayout = async (token, obligationId) => {
  try {
    const { data } = await api({
      method: "post",
      url: `/api/v1/admin/fundObligations/${obligationId}/payout`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      data,
    };
  } catch (error) {
    return {
      error,
      message: error?.response?.data?.message,
    };
  }
};
